import React, { FC, HTMLAttributes, useEffect, useRef, useState } from "react";
import { ElBanner, ElContent, ElContentColumn, elGapBanner, ElOdoBox, elShadow, ElSubTitle, ElTitle, ElValue } from "./impact.css";
import { Container } from "../../layout";
import { elFlexNoWrap } from "../../../@css-style";
import { cx } from "@linaria/core";
import { ElHeadLine } from "../head-title";
import { OdoMeter } from "./odo-meter";

interface IImpactProps extends HTMLAttributes<HTMLElement> {}

export const Impact: FC<IImpactProps> = ({ children, ...props }) => {
  const [isStart, setIsStart] = useState<boolean>(false);
  const elRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    animatedScroll();
  }, []);

  const animatedScroll = () => {
    window.document.addEventListener("scroll", (e) => {
      const triggerButton = (window.innerHeight / 5) * 4;
      if (elRef.current) {
        if (elRef.current?.getBoundingClientRect?.()?.top < triggerButton) {
          setIsStart(true);
        } else {
          setIsStart(false);
        }
      }
    });
  };

  return (
    <ElBanner {...props} ref={elRef}>
      <Container className={elGapBanner}>
        <ElContent>
          <ElHeadLine>Impacting Business</ElHeadLine>
          <ElSubTitle>Dampak rata-rata yang dihasilkan dalam 1-2 tahun</ElSubTitle>
        </ElContent>
        <ElContent className={cx(elFlexNoWrap, elShadow)}>
          <ElContentColumn>
            <ElOdoBox>
              <ElValue>
                <OdoMeter isStart={isStart} target={42.5} />
              </ElValue>
              <ElTitle>Peningkatan Revenue Bisnis</ElTitle>
            </ElOdoBox>
          </ElContentColumn>
          <ElContentColumn>
            <ElOdoBox>
              <ElValue>
                <OdoMeter isStart={isStart} target={58.1} />
              </ElValue>
              <ElTitle>Peningkatan Jumlah Pengguna</ElTitle>
            </ElOdoBox>
          </ElContentColumn>
          <ElContentColumn>
            <ElOdoBox>
              <ElValue>
                <OdoMeter isStart={isStart} target={36.3} />
              </ElValue>
              <ElTitle>Membuka Akses Pendanaan</ElTitle>
            </ElOdoBox>
          </ElContentColumn>
          <ElContentColumn>
            <ElOdoBox>
              <ElValue>
                <OdoMeter isStart={isStart} target={45.9} />
              </ElValue>
              <ElTitle>Peningkatan Kemitraan</ElTitle>
            </ElOdoBox>
          </ElContentColumn>
        </ElContent>
      </Container>
    </ElBanner>
  );
};
